import { render, staticRenderFns } from "./blessingCard.vue?vue&type=template&id=3e526730&scoped=true"
import script from "./blessingCard.vue?vue&type=script&lang=js"
export * from "./blessingCard.vue?vue&type=script&lang=js"
import style0 from "./blessingCard.vue?vue&type=style&index=0&id=3e526730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e526730",
  null
  
)

export default component.exports